module.exports = __webpack_public_path__ + "img/logo-white.d84288a0.svg";